import { Box } from "@chakra-ui/react";
import { Tree, TreeProps } from "antd";

export default function NodeTree({
  draggable,
  onDrop,
  children,
}: {
  draggable: boolean;
  onDrop: TreeProps["onDrop"];
  children: React.ReactNode;
}) {
  return (
    <Box
      sx={{
        ".nao-arrastavel .ant-tree-draggable-icon": {
          pointerEvents: "none",
          opacity: 0,
        },
        ".primeiro-nivel .ant-tree-draggable-icon": {
          display: "none",
        },
      }}
    >
      {
        <Tree
          key={draggable ? "draggable" : "not-draggable"}
          onDrop={onDrop}
          defaultExpandAll={draggable}
          draggable={draggable}
        >
          {children}
        </Tree>
      }
    </Box>
  );
}
